 
import logo from '../Components/images/logo.png';
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import React, { useEffect, useState } from "react";
import axios from "axios";


const Footer = () => {

  const navigate = useNavigate();

 const [whatsapp, setWhatsapp] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch existing WhatsApp number on load
  const fetchWhatsapp = async () => {
    try {
      const res = await axios.get("https://dropshopi.com/api/whatsapp.php");
      if (res.data.status === "success" && res.data.data?.numberwht) {
        setWhatsapp(res.data.data.numberwht);
      }
    } catch (err) {
      console.error("Error fetching WhatsApp number", err);
      Swal.fire("Error", "Failed to fetch current WhatsApp number.", "error");
    }
  };

  useEffect(() => {
    fetchWhatsapp();
  }, []);



return (

  <>
    <footer className="footer-dark text-white pt-5 pb-4 d-none d-lg-block">
      <div className="container px-5">
        <div className="row align-items-start">
          {/* Newsletter */}
          {/* Links */}
          <div className="col-lg-2 col-6 gvf mb-3" >
            <h6 className="fw-bold text-uppercase ft6">Pages</h6>
            <ul className="list-unstyled">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/services">Services</Link></li>
            </ul>
          </div>
          <div className="col-lg-2 col-6 gvf mb-3"  >
            <h6 className="fw-bold text-uppercase ft6">Information</h6>
            <ul className="list-unstyled"> 
              {/* <li><HashLink smooth to="/#faqAccordion">FAQ</HashLink></li> */}

              <li><Link to="/#faqAccordion">FAQ</Link></li>

              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
          <div className="col-lg-2 col-6 gvf mb-3"  >
            <h6 className="fw-bold text-uppercase ft6">Contact</h6>
            <ul className="list-unstyled">
              {/* <li><a href="#">LinkedIn</a></li> */}
              <li>
  <button
    onClick={() => window.location.href = "mailto:contact@dropshopi.com"}
    className="btn btn-outline-light mb-2" style={{minWidth: "100px"}}
  >
    Email
  </button>
</li>
{/* <li>
  <button
    onClick={() => window.open("https://wa.me/919911156024", "_blank")}
    className="btn btn-info" style={{backgroundColor: '#25D366', minWidth: "100px"}}
  >
    WhatsApp
  </button>
</li> */}

            </ul>
          </div>

          <div className="col-md-1"></div>


          <div className="col-lg-5 mb-4 mb-lg-0 d-flex align-items-start">
            <img src={logo} alt="Newsletter Icon" className="footer-icon me-3" />
            <div className=" ">
              <h5 className="fw-bold text-uppercase ft6">Join Our Newsletter</h5>
              <p className="footer-text">Sign up to our mailing list below and be the first to know about new updates. Don't worry, we hate spam too.</p>
        <form
  className="d-flex"
  onSubmit={(e) => {
    e.preventDefault();
    const email = e.target.email.value.trim();

    if (!email) {
      Swal.fire("Oops!", "Please enter a valid email address.", "warning");
      return;
    }

    fetch("https://dropshopi.com/api/newsletterSubscribe.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          e.target.reset();
          navigate("/thankyou-newsletter");
        } else {
          Swal.fire("Already Subscribed", data.message || "This email is already in our list.", "info");
        }
      })
      .catch((err) => {
        console.error("Error subscribing:", err);
        Swal.fire("Error", "Something went wrong. Please try again later.", "error");
      });
  }}
>
  <input
    type="email"
    name="email"
    placeholder="Your Email Address"
    className="form-control bg-dark border-0 text-white me-2 footer-input"
    required
  />
  <button type="submit" className="btn btn-warning rounded-pill px-4 fw-bold notif">
    Get Notified
  </button>
</form>

            </div>
          </div>


          
        </div>

        {/* Bottom line */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center pt-4 mt-4 border-top border-secondary">
          <p className="mb-0">&copy; Dropshopi 2025. All rights reserved. </p>
          <p className="mb-0">Designed by Motherwit Digital Solutions</p>
        </div>
      </div>
    </footer>






<footer className="footer-dark text-white pt-5 pb-4 d-block d-lg-none">
      <div className="container-fluid px-5">
        <div className="row align-items-start">
          {/* Newsletter */}
          {/* Links */}
          <div className="col-lg-2 col-6   mb-3" >
            <h6 className="fw-bold text-uppercase ft6">Pages</h6>
            <ul className="list-unstyled">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/services">Services</Link></li>
            </ul>
          </div>
          <div className="col-lg-2 col-6   mb-3"  >
            <h6 className="fw-bold text-uppercase ft6">Information</h6>
            <ul className="list-unstyled"> 
              {/* <li><HashLink smooth to="/#faqAccordion">FAQ</HashLink></li> */}

              <li><Link to="/#faqAccordion">FAQ</Link></li>

              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
          <div className="col-lg-2 col-6 gvf mb-3"  >
            <h6 className="fw-bold text-uppercase ft6">Contact</h6>
            <ul className="list-unstyled">
              {/* <li><a href="#">LinkedIn</a></li> */}
              {/* <li><a href="mail:contact@dropshopi.com">Email</a></li>
              <li>
  <a
    href="https://wa.me/919911156024"
    target="_blank"
    rel="noopener noreferrer"
  >
    WhatsApp
  </a>
</li> */}


<li>
  <button
    onClick={() => window.location.href = "mailto:contact@dropshopi.com"}
    className="btn btn-outline-light mb-2" style={{minWidth: "100px"}}
  >
    Email
  </button>
</li>
{/* <li>
  <button
    onClick={() => window.open("https://wa.me/919911156024", "_blank")}
    className="btn btn-info" style={{backgroundColor: '#25D366', minWidth: "100px"}}
  >
    WhatsApp
  </button>
</li> */}


            </ul>
          </div>

          <div className="col-md-1"></div>


          <div className="col-lg-5 mb-4 mb-lg-0   align-items-start">
            <img src={logo} alt="Newsletter Icon" className="footer-icon me-3 mb-3" />
            <div className=" ">
              <h5 className="fw-bold text-uppercase ft6">Join Our Newsletter</h5>
              <p className="footer-text">Sign up to our mailing list below and be the first to know about new updates. Don't worry, we hate spam too.</p>
             <form
  className="d-flex"
  onSubmit={(e) => {
    e.preventDefault();
    const email = e.target.email.value.trim();

    if (!email) {
      Swal.fire("Oops!", "Please enter a valid email address.", "warning");
      return;
    }

    fetch("https://dropshopi.com/api/newsletterSubscribe.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          e.target.reset();
          navigate("/thankyou-newsletter");
        } else {
          Swal.fire("Already Subscribed", data.message || "This email is already in our list.", "info");
        }
      })
      .catch((err) => {
        console.error("Error subscribing:", err);
        Swal.fire("Error", "Something went wrong. Please try again later.", "error");
      });
  }}
>
  <input
    type="email"
    name="email"
    placeholder="Your Email Address"
    className="form-control bg-dark border-0 text-white me-2 footer-input"
    required
  />
  <button type="submit" className="btn btn-warning rounded-pill px-2 fw-bold notif">
    Get Notified
  </button>
</form>
            </div>
          </div>


          
        </div>

        {/* Bottom line */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center pt-4 mt-4 border-top border-secondary">
          <p className="mb-0">&copy; Dropshopi 2025. All rights reserved. </p>
          <p className="mb-0">Designed by Motherwit Digital Solutions</p>
          </div>
      </div>
    </footer>


<div>
  <a
  href={`https://wa.me/${whatsapp}`}  
  className="whatsapp-float"
  target="_blank"
  rel="noopener noreferrer"
>
  <i className="fab fa-whatsapp"></i>
</a>
</div>




    </>


  );
};

export default Footer;
